import { fetchClient } from '../../Utils/helpers';
import {
  ADD_ADDRESS, DELETE_ADDRESS, GET_ADDRESS, UPDATE_ADDRESS,
} from '../actionTypes';

const setMainAddress = (userId, addressId) => fetchClient({
  method: 'PATCH',
  url: `/user-address/${userId}/address/${addressId}/set-default`,
});

export function insertAddress(userId, data, setMain) {
  return {
    type: ADD_ADDRESS,
    payload: fetchClient({
      method: 'POST',
      url: `/user-address/${userId}/address`,
      data,
    }).then(async (res) => {
      if (setMain) await setMainAddress(userId, res.data.data.id);

      return res;
    }),
  };
}

export function updateAddress(userId, addressId, data, setMain) {
  return {
    type: UPDATE_ADDRESS,
    payload: fetchClient({
      method: 'PUT',
      url: `/user-address/${userId}/address/${addressId}`,
      data,
    }).then(async (res) => {
      if (setMain) {
        await setMainAddress(userId, res.data.data.id);
      }
      return res;
    }),
  };
}

export function deleteAddress(userId, addressId) {
  return {
    type: DELETE_ADDRESS,
    payload: fetchClient({
      method: 'DELETE',
      url: `/user-address/${userId}/address/${addressId}`,
    }).then(() => addressId),
  };
}

export function getAddress(userId) {
  return {
    type: GET_ADDRESS,
    payload: fetchClient({
      method: 'GET',
      url: `/user-address/${userId}/addresses`,
    }),
  };
}
